import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Backdrop } from '@material-ui/core';
import Spinner from './Spinner';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.action.disabledBackground,
      opacity: 0.5,
    },
  }),
);

interface Props {
  isOpen: boolean;
  spinner?: boolean;
}

const SubmitLoading: React.FC<Props> = (props) => {
  const { isOpen, spinner } = props;
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={isOpen} invisible>
      {spinner && <Spinner />}
    </Backdrop>
  );
};

export default SubmitLoading;
